import { Modal } from "ui/Modal"
import { Title, Text } from "ui/Typography"
import { Button, Flex } from "antd"
import WarningOutlinedWithBg from "ui/WarningOutlinedWithBg"
import { spacings } from "themes/variables"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

const DeletionUnavailable = ({ visible, onCancel, onDeactivate }) => {
  const { t } = useTranslation()
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      centered
      title={
        <Flex justify="center">
          <WarningOutlinedWithBg />
        </Flex>
      }
      width={450}
    >
      <Flex vertical gap={spacings.M}>
        <Title level={3}>{t("settings.account_deletion_unavailable")}</Title>
        <Text>{t("settings.account_deletion_unavailable_description")}</Text>
        <Button type="primary" onClick={onDeactivate} size="large" className="w-fit">
          {t("global.got_it")}
        </Button>
      </Flex>
    </Modal>
  )
}

DeletionUnavailable.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  onDeactivate: PropTypes.func
}

export default DeletionUnavailable
